/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type RemoveUserContactMutationVariables = Types.Exact<{
  contactId: Types.Scalars['ID'];
  contactType: Types.ContactType;
}>;


export type RemoveUserContactMutation = (
  { __typename?: 'Mutation' }
  & { removeUserContact: Types.Maybe<(
    { __typename?: 'ValidatingOperationResult' }
    & Pick<Types.ValidatingOperationResult, 'successful'>
    & { errors: Types.Maybe<Array<(
      { __typename?: 'ValidationItem' }
      & Pick<Types.ValidationItem, 'messages'>
    )>> }
  )> }
);


export const RemoveUserContactDocument = gql`
    mutation removeUserContact($contactId: ID!, $contactType: ContactType!) {
  removeUserContact(contactId: $contactId, contactType: $contactType) {
    successful
    errors {
      messages
    }
  }
}
    `;
export type RemoveUserContactMutationFn = Apollo.MutationFunction<RemoveUserContactMutation, RemoveUserContactMutationVariables>;

/**
 * __useRemoveUserContactMutation__
 *
 * To run a mutation, you first call `useRemoveUserContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserContactMutation, { data, loading, error }] = useRemoveUserContactMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      contactType: // value for 'contactType'
 *   },
 * });
 */
export function useRemoveUserContactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserContactMutation, RemoveUserContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserContactMutation, RemoveUserContactMutationVariables>(RemoveUserContactDocument, options);
      }
export type RemoveUserContactMutationHookResult = ReturnType<typeof useRemoveUserContactMutation>;
export type RemoveUserContactMutationResult = Apollo.MutationResult<RemoveUserContactMutation>;
export type RemoveUserContactMutationOptions = Apollo.BaseMutationOptions<RemoveUserContactMutation, RemoveUserContactMutationVariables>;